<template>
  <div class="container px-4">
    <br />
    <div v-for="item in items" :key="item.title">
      <div v-if="!item.hidden" class="d-flex w-100 mt-3">
        <img :src="useAsset(`img/credit-line/${item.icon}`)" alt="amount" />
        <div class="ms-3">
          <p class="fw-bold text-black my-0">
            {{ item.title }}
          </p>
          <p class="my-0">{{ item.description }}</p>
        </div>
      </div>
    </div>
    <div class="w-100 mt-4 alert px-3">
      <Alert
        v-if="showAlert"
        class="mx-3"
        :message="alertMessage"
        alertIcon="fa fa-info-circle"
        alertType="alert-warning"
        @onClose="$emit('closeAlert')"
      />
    </div>
    <div class="floating-btn-placeholder" />
    <div class="floating-btn">
      <Button id="btn-continue" class="text-start w-100 p-3" @click="clickBtn">
        <div class="text-white text-start my-auto fw-bold btn-text">
          <span>{{ t("CL_WITHDRAWAL.CONFIRM_DETAILS") }}</span>
          <span>&#10095;</span>
        </div>
      </Button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import Button from "@/apps/credit-line/components/Button.vue";
import { IBankOptionInfo } from "@/apps/credit-line/models/IBankOptionInfo";
import Alert from "@/shared-components/common/Alert.vue";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";

export default defineComponent({
  name: "NewAccountDetails",
  components: { Alert, Button },
  props: {
    clabe: {
      type: String,
      default: "",
    },
    bank: {
      type: Object as PropType<IBankOptionInfo>,
      default: () => ({}),
    },
    curp: {
      type: String,
      default: "",
    },
    requiresIdentityVerification: {
      type: Boolean,
      default: true,
    },
    alertMessage: {
      type: String,
      default: "",
    },
    showAlert: Boolean,
  },
  emits: ["next", "setScreenTitle", "closeAlert"],
  setup(props, { emit }) {
    const { t } = useI18n();
    // Parse CLABE to format "xxx xxx xxxxxxxxxxx x"
    const parsedClabe = props.clabe
      .replace(/^(\d{3})(\d)/g, "$1 $2")
      .replace(/^(\d{3}\s)(\d{3})(\d)/g, "$1$2 $3")
      .replace(/^(\d{3}\s)(\d{3}\s)(\d{11})(\d)/g, "$1$2$3 $4");
    const items = [
      {
        title: parsedClabe,
        description: t("CL_WITHDRAWAL.CLABE_NUMBER"),
        icon: "withdrawal_icon5.png",
        hidden: false,
      },
      {
        title: props.bank.participantKey,
        description: t("CL_WITHDRAWAL.BANK_INTITUTION"),
        icon: "bank-icon.png",
        hidden: false,
      },
      {
        title: props.curp,
        description: t("CL_WITHDRAWAL.CURP_LAST_CHARS"),
        icon: "id-icon.png",
        hidden: !props.requiresIdentityVerification,
      },
    ];

    const clickBtn = () => {
      emit("next");
    };

    onMounted(() => {
      emit("setScreenTitle", t("CL_WITHDRAWAL.REVIEW_DETAILS"));
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.AccountDetailsConfirmationScreen,
        "Withdrawal"
      );
    });
    return { items, clickBtn, useAsset, t };
  },
});
</script>

<style lang="scss" scoped>
.alert {
  position: fixed;
  padding: 10px 20px;
  left: 0;
  right: 0;
  bottom: 15%;
  z-index: 200;
}
.btn-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.floating-btn-placeholder,
.floating-btn {
  height: 80px;
  width: 100%;
}
.floating-btn {
  background-color: white;
  position: fixed;
  padding: 10px 20px;
  left: 0;
  bottom: 0;
  z-index: 200;
}
</style>
